// ─────────────────────────────────────────────────────────────────────────────
// TERMS & CONDITIONS
//
// Paste your full Terms & Conditions text below, replacing the placeholder.
// The text supports plain paragraphs separated by blank lines.
// ─────────────────────────────────────────────────────────────────────────────

export const TERMS_TEXT = `
TERMS AND CONDITIONS

Last updated: [Date]

Paste your full Terms & Conditions text here. You can use plain text with
blank lines to separate paragraphs. The modal will display it in a scrollable
container with preserved line breaks.

1. ACCEPTANCE OF TERMS
Replace this placeholder with your actual terms.

2. USE OF SERVICE
Replace this placeholder with your actual terms.

3. PRIVACY
Replace this placeholder with your actual terms.
`;
